import React from 'react';

import HeaderSectionControlOld from './HeaderSectionControlOld/HeaderSectionControlOld';
import HeaderSectionJobsSearchA from './HeaderSectionJobsSearchA/HeaderSectionJobsSearchA';
import HeaderSectionJobsSearchB from './HeaderSectionJobsSearchB/HeaderSectionJobsSearchB';
import HeaderSectionJobsSearchC from './HeaderSectionJobsSearchC/HeaderSectionJobsSearchC';

const HeaderSection = ({
  isJobsSearchControlVersion,
  isJobsSearchVariantOneVersion,
  isJobsSearchVariantTwoVersion,
}) => {
  if (isJobsSearchControlVersion) {
    return <HeaderSectionJobsSearchA />;
  }

  if (isJobsSearchVariantOneVersion) {
    return <HeaderSectionJobsSearchB />;
  }

  if (isJobsSearchVariantTwoVersion) {
    return <HeaderSectionJobsSearchC />;
  }

  return <HeaderSectionControlOld />;
};

export default HeaderSection;
